import { atom } from 'recoil'

export const isOpenMenuUnitsState = atom({
  key: 'isOpenMenuUnitsState',
  default: false
})
